import type { RouteDefinition } from "@tchoma/runtime-web";

export type InboxRouteId = "inbox" | "archive" | "settings" | "capture";

export function createInboxRoutes(publicUrl?: string): readonly RouteDefinition<InboxRouteId>[] {
  const basePath = inboxBasePath(publicUrl);
  const path = (suffix: "" | "/archive" | "/settings" | "/capture") => basePath === "/" ? suffix || "/" : `${basePath}${suffix}`;
  return [
    { id: "inbox", path: path(""), title: "Inbox" },
    { id: "archive", path: path("/archive"), title: "Archive · Inbox" },
    { id: "settings", path: path("/settings"), title: "Settings · Inbox" },
    { id: "capture", path: path("/capture"), title: "Confirm capture · Inbox" },
  ];
}

export function inboxServiceWorkerUrl(publicUrl?: string): string {
  const basePath = inboxBasePath(publicUrl);
  return basePath === "/" ? "/sw.js" : `${basePath}/sw.js`;
}

export const INBOX_ROUTES = createInboxRoutes();

function inboxBasePath(publicUrl?: string): string {
  if (!publicUrl) return "/";
  const pathname = new URL(publicUrl).pathname.replace(/\/+$/u, "");
  return pathname || "/";
}
